import { Flex } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { BoxIcon } from "ui/Icons/Icons";
import { TitleXS } from "ui/Typography/Typography";

type ItemsExpectedBarProps = {
  isUnitTypeHandlingUnit: boolean;
  numberOfUnits: number;
};

export function ItemsExpectedBar({ isUnitTypeHandlingUnit, numberOfUnits }: ItemsExpectedBarProps) {
  const intl = useIntl();
  const itemsExpectedLabel = intl.formatMessage({
    id: "flows.inbound.pre-dropping.product-information.items-expected",
  });

  const { unitsLabel, color } = isUnitTypeHandlingUnit
    ? {
        unitsLabel: intl.formatMessage(
          { id: "flows.inbound.pre-dropping.product-information.handling-units-label" },
          { count: numberOfUnits },
        ),
        color: "orange.500",
      }
    : {
        unitsLabel: intl.formatMessage(
          { id: "flows.inbound.pre-dropping.product-information.single-units-label" },
          { count: numberOfUnits },
        ),
        color: "marine.500",
      };

  return (
    <Flex gap={1} alignItems="center">
      <BoxIcon color={color} boxSize="18px" data-testid="facings-icon" />
      <TitleXS data-testid="facings-unit-title">{itemsExpectedLabel}</TitleXS>
      <TitleXS data-testid="facings-unit-quantity">{numberOfUnits}</TitleXS>
      <TitleXS data-testid="facings-unit-type">{unitsLabel}</TitleXS>
    </Flex>
  );
}
